<template>
    <div
        style="position: fixed; bottom: 0; width: 100%; color: #5f6368; background:#fff; display: flex; justify-content: center; align-items: center; font-size: 13px; font-weight: 600;padding-top: 10px;">
        <van-row style="width:100%" justify="space-between">
            <van-col :span="4">
                <div class="footerCont">
                    <img class="imageCont" src="@/assets/download/sport.png" />
                    <span>{{ $t('download.sport') }}</span>
                </div>
            </van-col>
            <van-col :span="4">
                <div class="footerCont" style="color: #01875f;">
                    <img class="imageCont" src="@/assets/download/app.png" />
                    <span>{{ $t('download.app') }}</span>
                </div>
            </van-col>
            <van-col :span="4">
                <div class="footerCont">
                    <img class="imageCont" src="@/assets/download/film.png" />
                    <span>{{ $t('download.film') }}</span>
                </div>
            </van-col>
            <van-col :span="4">
                <div class="footerCont">
                    <img class="imageCont" src="@/assets/download/book.png" />
                    <span>{{ $t('download.book') }}</span>
                </div>
            </van-col>
            <van-col :span="4">
                <div class="footerCont">
                    <img class="imageCont" src="@/assets/download/star.png" />
                    <span>{{ $t('download.child') }}</span>
                </div>
            </van-col>
        </van-row>

    </div>
</template>
<script setup lang="ts">

</script>

<style scoped>
.footerItem {
    height: 50px;
    width: 50px;
}

.footerCont {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    text-align: center;
}

.imageCont {
    height: 30px;
    width: 30px;
    object-fit: contain;
    display: flex;
    justify-content: center;
}
</style>